export const FIRST_YEAR_UPFRONT_PERCENT = 0.3;
export const FIRST_YEAR_MONTHS = 11;
export const FIRST_YEAR_MONTHLY_INTEREST = 0.048;
export const SUBSEQUENT_YEAR_MONTHS = 12;
export const SUBSEQUENT_YEAR_MONTHLY_INTEREST = 0.044;

export function getVerificationFee(annualRent) {
  const rent = Number(annualRent) || 0;
  return rent >= 1000000 ? 20000 : 10000;
}

export function calculateFirstYearPlan(annualRent) {
  const rent = Number(annualRent) || 0;
  const upfront = Math.ceil(rent * FIRST_YEAR_UPFRONT_PERCENT);
  const remaining = rent - upfront;
  const monthly = Math.ceil((remaining + remaining * FIRST_YEAR_MONTHLY_INTEREST * FIRST_YEAR_MONTHS) / FIRST_YEAR_MONTHS);
  return {
    annualRent: rent,
    upfront,
    remaining,
    monthly,
    verificationFee: getVerificationFee(rent),
    months: FIRST_YEAR_MONTHS,
  };
}

export function calculateSubsequentYearMonthly(annualRent) {
  const rent = Number(annualRent) || 0;
  return Math.ceil((rent + rent * SUBSEQUENT_YEAR_MONTHLY_INTEREST * SUBSEQUENT_YEAR_MONTHS) / SUBSEQUENT_YEAR_MONTHS);
}
